import { render, staticRenderFns } from "./FeelingBars.vue?vue&type=template&id=48fd87ea&scoped=true&lang=pug"
import script from "./FeelingBars.vue?vue&type=script&lang=js"
export * from "./FeelingBars.vue?vue&type=script&lang=js"
import style0 from "./FeelingBars.vue?vue&type=style&index=0&id=48fd87ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fd87ea",
  null
  
)

export default component.exports